<template>
    <router-link
        v-ripple
        :to="goTo"
        class="history"
        :class='size'
        :style="{
            'background-image': `url(${history.type == 'live' && history.details.country !== '24/7' ? '' : history.logos[0]})`,
            'background-color': history.color,
            'border': (needsBorder) ? '3px solid #2c2b2b' : ''
        }"
    >
        <img :src="history.logos[0]" v-if="history.type == 'live' && history.details.country !== '24/7'"/>
        <p> {{history.name}} </p>
    </router-link>
</template>

<script>

export default {
  name: 'history',
  props: {
    history: Object,
    size: {
        type: String,
        default: function(){ return ''}
    }
  },

  computed: {
        goTo(){
            return `/${this.location()}/${this.history.id}`
            //if(this.isDesktop){ return `/${this.location()}/${this.history.id}` }
        },
        needsBorder(){
            if (!this.history){return false}
            return (!this.history.color || this.history.color === 'rgb(20, 20, 20, 0.8)') && this.history.type === 'live'
        }
},

  data: function(){
      return {}
  },

  methods: {
    location(){
        if(this.history.type == 'live'){
            return 'channel'
        }
        if(this.history.type == 'od'){
            return this.history.details.contentType
        }

        return this.history.type
    }
  },

  mounted: function(){ }
}
</script>

<style scoped lang="scss">
.history{
    position: relative;
    box-sizing: border-box;
    border-radius: 10px;
    background-size: cover;
    background-position: center;
    height: 300px;
    width: 100vw;
    color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p{
        margin: 0;
        padding: 0;
        height: 0;
        opacity:0;
    }
    img{
        max-height: 50%;
        max-width: 50%;
    }
    &.fit{
        width: 100%;
        height: 100%;
    }
 }
</style>
